import Cookies from 'js-cookie';

/**
 * path匹配到环境为止的正则
 * 例如: /ebike-h5/{env}
 */
const cookiePathReg = /\/[^/]+\/([^/]+\/)?/;
export const pathMatch = (pathname) => {
  const matches = pathname.match(cookiePathReg);
  if (matches) {
    return matches[0];
  }
  return pathname;
};

function getKey(key) {
  return `${key}_h5_${
    (window.env && window.env.VUE_APP_ENV) || process.env.NODE_ENV
  }`;
}

export const tld = (hostname) => {
  // 本地调试通过localhost或IP访问
  if (hostname === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    return hostname;
  }
  return hostname.split('.').slice(1).join('.');
};

const getCurrentPath = () => pathMatch(window.location.pathname);

const getTopLevelDomain = () => tld(window.location.hostname);

export default class CookieUtil {
  static getItem(key) {
    return Cookies.get(getKey(key));
  }

  static setItem(key, val, expirationDate) {
    if (val !== undefined) {
      return Cookies.set(getKey(key), val, {
        path: getCurrentPath(),
        domain: getTopLevelDomain(),
        expires: expirationDate || 3650,
      });
    }
    return undefined;
  }

  static removeItem(key) {
    Cookies.remove(getKey(key), {
      path: getCurrentPath(),
      domain: getTopLevelDomain(),
    });
  }
}
